<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Portal Settings</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <b-row>
        <b-col xl="12">
          <b-card no-body>
            <b-card-body v-if="totalShowStatus">
              <transition name="slide-fade">
                <div>
                  <b-row class="mt-2 ,b-3">
                    <b-col xl="3" md="3" sm="12"></b-col>
                    <b-col xl="7" md="7" sm="12"></b-col>
                    <b-col xl="2" md="2" sm="12" class="text-right">
                      <base-button type="success" title="New" size="sm" class="mt-2 mb-3" v-on:click="totalShowStatus = false" >
                          <i class="fas fa-plus"></i> New
                      </base-button>
                    </b-col>
                  </b-row>
                  <div class="text-center w-100">
                    <b-icon icon="three-dots"
                            class="text-center " animation="cylon"
                            font-scale="4"
                            v-if="loadingStatus"></b-icon>
                  </div>

                  <div class="mb-3" v-if="!loadingStatus">

                    <b-row>
                      <b-col xl="8" lg="7" md="7" sm="12">

                        <b-form-group
                          label=""
                          label-for="per-page-select"
                          label-cols-sm="0"
                          label-cols-md="0"
                          label-cols-lg="0"
                          label-align-sm="center"
                          label-size="sm"
                          class="mb-2 per-page-select"
                        >
                          <label for="per-page-select" class="mr-2 text-sm">Show</label>
                          <b-form-select
                            id="per-page-select"
                            class="diameter-report-select"
                            v-model="perPage"
                            :options="pageOptions"
                            v-on:input="changePageOption(perPage)"
                            size="sm"
                          ></b-form-select>
                          <label for="per-page-select" class="ml-2 text-sm">entries</label>
                        </b-form-group>

                      </b-col>
                      <b-col xl="4" lg="5" md="5" sm="12 customer-table-select">
                        <b-form-group
                          label=""
                          label-for="filter-input"
                          label-align-sm="right"
                          label-size="sm "
                          class="mb-0 per-page-select"
                        >
                          <label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
                          <b-input-group size="sm">
                            <b-form-input
                              id="filter-input"
                              v-model="filter"
                              class="mb-4"
                            ></b-form-input>

                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-table
                      striped hover
                      :items="tableData"
                      :fields="tableColumns"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      head-variant="light"
                      table-class="text-nowrap"
                      class="data-management-table"
                      sticky-header="true"
                      show-empty
                      responsive
                      small
                    >
                      <template #cell(action)="row">
                       <span>
                         <i class="fas fa-pen-nib mr-3 cursor-pointer text-success" v-on:click="editRow(row.item)"></i>
                         <i class="fas fa-trash-alt cursor-pointer text-danger" v-on:click="deleteRow(row.item.id)"></i>
                       </span>
                      </template>
                    </b-table>

                    <b-row class="mt-4">
                      <b-col>
                        <p class="ml-3"> {{ startPage }} - {{ fromPage }} of {{ totalRows }} </p>
                      </b-col>
                      <b-col xl="auto" md="auto" sm="auto ">
                        <b-pagination
                          class="flex-fill-custom pr-4 ml-3"
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          v-on:input="paginationChanged(currentPage)"
                          size="sm"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                  </div>
                </div>

              </transition>
            </b-card-body>


            <b-card-header  v-if="!totalShowStatus" v-on:click="totalShowStatus = !totalShowStatus">
              <h3 class="mb-0">
                <i class="fas fa-chevron-left cursor-pointer"></i>
              </h3>
            </b-card-header>


            <b-card-body v-if="!totalShowStatus">
              <form>
                <b-row class="form-group">
                  <label class="col-md-2 col-form-label form-control-label">API Version</label>
                  <b-col md="10">
                    <base-input placeholder="API Version" v-model="settingsForm.api_version"></base-input>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <label for="example-search-input" class="col-md-2 col-form-label form-control-label">Client</label>
                  <b-col md="10">
                    <base-input id="example-search-input" placeholder="Client" v-model="settingsForm.client"></base-input>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <label for="example-email-input" class="col-md-2 col-form-label form-control-label">Flag</label>
                  <b-col md="10">
                    <base-input  placeholder="Flag" id="example-email-input" v-model="settingsForm.flag" />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <label for="example-url-input" class="col-md-2 col-form-label form-control-label">Head</label>
                  <b-col md="10">
                    <base-input placeholder="Head" id="example-url-input" v-model="settingsForm.head"/>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <label for="example-tel-input" class="col-md-2 col-form-label form-control-label">Key</label>
                  <b-col md="10">
                    <base-input  placeholder="Key" id="example-tel-input" v-model="settingsForm.key"/>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <label for="example-password-input"
                         class="col-md-2 col-form-label form-control-label">Region</label>
                  <b-col md="10">
                    <base-input placeholder="Region" id="example-password-input" v-model="settingsForm.region"/>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <label for="example-number-input" class="col-md-2 col-form-label form-control-label">Type</label>
                  <b-col md="10">
                    <base-input  placeholder="Type" id="example-number-input" v-model="settingsForm.type"/>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <label for="ux_version" class="col-md-2 col-form-label form-control-label">UX Version</label>
                  <b-col md="10">
                    <base-input  placeholder="UX Version" id="ux_version" v-model="settingsForm.ux_version"/>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <label for="value" class="col-md-2 col-form-label form-control-label">Value</label>
                  <b-col md="10">
<!--                    <v-jsoneditor id="value" v-model="settingsForm.value" :options="{ mode: 'code' }" :plus="false" height="400px" />-->
                  </b-col>
                </b-row>
                <b-row class="form-group text-right">
                  <b-col md="12" class="text-right">
                    <base-button type="primary" title="Submit" size="sm" class="mt-2 mb-3" v-on:click="settingsSubmit(settingsForm.id)" :loading="submitLoading">
                         Submit
                    </base-button>
                  </b-col>
                </b-row>
              </form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </base-header>
  </div>

</template>

<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import administratorService from "@/common/api-services/administrator-service";
  import handleResponse from "../../../common/directive/handlResponse";
  //import VJsoneditor from 'v-jsoneditor/src/index'
  import swal from "sweetalert2";

  export default {
    name: "Portal-Settings",
    components: {
      RouteBreadCrumb,
      //VJsoneditor
    },
    data() {
      return {
        settingsForm: {
          api_version: '',
          client: '',
          flag: '',
          head: '',
          id: '',
          key: '',
          region: '',
          type: '',
          ux_version: '',
          value: ''
        },
        groupOption: [],
        loadingStatus: false,
        submitLoading: false,
        totalRows: 0,
        currentPage: 1,
        pageOptions: [10, 25, 50, 100],
        perPage: 10,
        tableColumns: [
          {key: "action", label: "Action"},
          {key: "api_version", label: "API Version", sortable: true, sortDirection: 'desc'},
          {key: "client", label: "Client", sortable: true, sortDirection: 'desc'},
          {key: "flag", label: "Flag", sortable: true, sortDirection: 'desc'},
          {key: "head", label: "Head", sortable: true, sortDirection: 'desc'},
          {key: "id", label: "Id", sortable: true, sortDirection: 'desc'},
          {key: "key", label: "Key", sortable: true, sortDirection: 'desc'},
          {key: "region", label: "Region", sortable: true, sortDirection: 'desc'},
          {key: "type", label: "Type", sortable: true, sortDirection: 'desc'},
          {key: "ux_version", label: "UX Version", sortable: true, sortDirection: 'desc'},
          {key: "value", label: "Value", sortable: true, sortDirection: 'desc'},
        ],
        tableData: [],
        localData: [],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        startPage: 1,
        fromPage: 10,
        lastPage: 1,
        totalShowStatus: true,
        editStatus: false,
      }
    },
    mounted() {
      this.getPortalSettingsFunc();
      document.title = 'Portal Settings'
    },
    methods: {
      getPortalSettingsFunc() {
        this.tableData = [];
        this.loadingStatus = true;
        administratorService.getPortalSettings().then(res => {
          this.loadingStatus = false;
          for (let item of res) {
            this.tableData.push(item)
          }
          this.totalRows = this.tableData.length;
          this.paginationChanged(this.currentPage)
        })
      },

      changePageOption(page) {
        this.getTotalRows()
      },
      getTotalRows() {
        if (this.perPage > this.totalRows) {
          this.fromPage = this.totalRows
        } else {
          this.fromPage = this.perPage
        }
      },
      paginationChanged(data) {
        if (data * this.perPage < this.totalRows) {
          this.fromPage = data * this.perPage;
        } else {
          this.fromPage = this.totalRows
        }

        this.currentPage = data;
        this.startPage = (this.currentPage - 1) * this.perPage + 1;
      },

      editRow(data) {
        this.totalShowStatus = false;
        this.editStatus = true;
        this.settingsForm.api_version = data.api_version;
        this.settingsForm.client = data.client;
        this.settingsForm.flag = data.flag;
        this.settingsForm.head = data.head;
        this.settingsForm.key = data.key;
        this.settingsForm.id = data.id;
        this.settingsForm.region = data.region;
        this.settingsForm.type = data.type;
        this.settingsForm.ux_version = data.ux_version;
        switch (data.value) {
          case "true":
            this.settingsForm.value = "true";
            break;
          case "false":
            this.settingsForm.value = "false";
            break;
          default:
            try{
              this.settingsForm.value = JSON.parse(data.value);
            }
            catch (e) {
              this.settingsForm.value = data.value;
            }
        }
      },

      settingsSubmit(id) {
        this.submitLoading = true;
        if (this.editStatus) {
          administratorService.updatePortalSettings(id, encodeURI(JSON.stringify(this.settingsForm))).then(res => {
            this.totalShowStatus = true;
            this.submitLoading = false;
            let {type, msg} = handleResponse.apiResponse(res);
            this.$toast(msg, {timeout:45000, type: type})
            this.getPortalSettingsFunc();
          })
        } else {
          administratorService.setPortalSettings(encodeURI(JSON.stringify(this.settingsForm))).then(res => {
            this.totalShowStatus = true;
            this.submitLoading = false;
            let {type, msg} = handleResponse.apiResponse(res);
            this.$toast(msg, {timeout:45000, type: type})
            this.getPortalSettingsFunc();
          })
        }
      },
      deleteRow(id) {
        swal.fire({
          title: `Users`,
          text: `Delete selected portal user? ${id}`,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          customClass: {
						cancelButton: 'order-1 mr-3',
						confirmButton: 'btn btn-danger order-2',
					},
        }).then((result) => {
          if (result.isConfirmed) {
            administratorService.deletePortalSettings(id).then(res => {
              let {type, msg} = handleResponse.apiResponse(res);
              this.$toast(msg, {timeout:45000, type: type})
              this.getPortalSettingsFunc();
            })
          }
        })
      }

    }
  }
</script>

<style>

</style>
